import React, { useState } from "react";

import Loading from "../../../../Components/Interactive/Loading";
// MUI Imports
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import MemberEventsTable from "./MemberEvents/MemberEventsTable";

const MemberEventsWidget = ({ allCustomerData, loading }) => {
  const {
    userEvents: { events, totalMemberEvents },
  } = allCustomerData;
  const [open, setIsOpen] = useState(false);
  const [toggleDropdown, setToggleDropdown] = useState(false);
  return (
    <div className="user-data-container" style={{marginBottom: "1rem"}}>
      {loading ? (
        <div className="loading-widget">
          <Loading />
        </div>
      ) : (
        <>
          <div className="customer-widget-header">
            <p
              className="customer-widget-heading"
              style={{ width: "100%", padding: ".5rem .5rem" }}
            >
              Member Events
              <ArrowDropDownIcon
                onClick={() => {
                  setIsOpen(!open);
                  setToggleDropdown(!toggleDropdown);
                }}
                className={`arrow-dropdown ${
                  toggleDropdown ? "arrow-open" : "arrow-close"
                }`}
              />
            </p>
            {!open && (
              <p className="closed-details-text"
              >
                Total Events - {totalMemberEvents}
              </p>
            )}
          </div>
          <div
            className={`${
              open ? "show-data-table-call" : "no-data-table-call"
            }`}
          >
            {events && events?.length >= 0 && (
              <MemberEventsTable
                userEvents={events}
                totalMemberEvents={totalMemberEvents}
                open={open}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};
export default MemberEventsWidget;
